import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TablePageSize } from '@shared/interfaces/table/table-pagesize';
import { FormsModule } from '@angular/forms';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { SelectDirective } from '@shared/components/input/select/select.directive';

@Component({
  selector: 'app-table-pagesize',
  imports: [
    FormsModule,
    SelectDirective
  ],
  templateUrl: './table-pagesize.component.html',
  styleUrl: './table-pagesize.component.css'
})
export class TablePagesizeComponent {
  private readonly defaultSizes: KeyValue[] = [{ key: '10', value: '10' }, { key: '25', value: '25' }, { key: '50', value: '50' }, { key: '100', value: '100' }];

  @Input() public pageSize: TablePageSize = 10;
  @Input() public pageSizeOptions?: KeyValue[];

  @Output() public pageSizeChange: EventEmitter<TablePageSize> = new EventEmitter();

  public get pageSizeList(): KeyValue[] { return this.pageSizeOptions?.length ? this.pageSizeOptions : this.defaultSizes; }

  public onPageSizeChange(): void {
    // ngModelChange can fire twice when SelectDirective converts the raw DOM
    // string to a number: once with the string value (from Angular's CVA) and
    // once with the numeric value (after SelectDirective's conversion).
    // Guard here so pageSizeChange only emits when we have the final number.
    if (typeof this.pageSize !== 'number') return;
    this.pageSizeChange.emit(this.pageSize);
  }
}
